import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="py-20 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Refund Policy</h1>
            <p className="text-slate-400 mb-8">Last updated: February 2026</p>
            
            <div className="prose prose-invert max-w-none space-y-8">
              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">1. Overview</h2>
                <p className="text-slate-300 leading-relaxed">
                  At TCUBE FITNESS, we are committed to your satisfaction. This Refund Policy outlines the terms and conditions for refunds on our online coaching services.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">2. Free Consultation</h2>
                <p className="text-slate-300 leading-relaxed">
                  We offer a free initial consultation to help you understand our services and determine if they are right for you. There is no obligation to purchase after this consultation.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">3. Refund Eligibility</h2>
                <p className="text-slate-300 leading-relaxed mb-4">Refunds may be considered under the following circumstances:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li><strong>Within 7 days of enrollment:</strong> Full refund if you have not received any program materials or attended any consultations.</li>
                  <li><strong>Medical emergencies:</strong> Partial refund or program pause may be considered with valid medical documentation.</li>
                  <li><strong>Service not delivered:</strong> Full refund if we fail to deliver the promised services.</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">4. Non-Refundable Situations</h2>
                <p className="text-slate-300 leading-relaxed mb-4">Refunds will not be provided in the following cases:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li>After program materials have been delivered and consultations have begun</li>
                  <li>Lack of results due to not following the prescribed program</li>
                  <li>Personal reasons unrelated to our service quality</li>
                  <li>Requests made after 7 days of enrollment (except for documented medical emergencies)</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">5. Program Pause Option</h2>
                <p className="text-slate-300 leading-relaxed">
                  If you are unable to continue your program due to genuine reasons, we may offer to pause your program for up to 4 weeks instead of a refund. This allows you to resume your journey when ready.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">6. Refund Process</h2>
                <p className="text-slate-300 leading-relaxed mb-4">To request a refund:</p>
                <ol className="list-decimal list-inside text-slate-300 space-y-2">
                  <li>Contact us via email at support@tcubefitness.com or <a href="https://api.whatsapp.com/send/?phone=919515902777&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300">WhatsApp at +91 9515902777</a></li>
                  <li>Provide your enrollment details and reason for the refund request</li>
                  <li>Submit any supporting documentation if applicable</li>
                  <li>Our team will review your request within 5 business days</li>
                  <li>If approved, refunds will be processed within 7-10 business days</li>
                </ol>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">7. Our Commitment</h2>
                <p className="text-slate-300 leading-relaxed">
                  We believe in the effectiveness of our programs. If you follow the program as prescribed and do not see results, we will work with you to adjust your plan. Your success is our priority, and we are committed to supporting you throughout your journey.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">8. Contact Us</h2>
                <p className="text-slate-300 leading-relaxed">
                  For refund inquiries or to discuss your situation, please reach out to us:
                </p>
                <div className="text-slate-300 mt-4 space-y-2">
                  <p><strong>Email:</strong> support@tcubefitness.com</p>
                  <p>
                    <strong>WhatsApp:</strong>{' '}
                    <a 
                      href="https://api.whatsapp.com/send/?phone=919515902777&text&type=phone_number&app_absent=0"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-400 hover:text-emerald-300 transition-colors"
                    >
                      +91 9515902777
                    </a>
                  </p>
                  <p><strong>Response Time:</strong> Within 24-48 hours</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RefundPolicyPage;
